import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'plan-selection-page-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.SELECTION,
};
